import { render } from "./CardPortrait.vue?vue&type=template&id=4eca2aa8"
import script from "./CardPortrait.vue?vue&type=script&lang=js"
export * from "./CardPortrait.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__